import { ERestrictionType } from '../../../../../../reducers/v2/paidPublication/types';
import React from 'react';
import { SubAgentPublicationLimitExceedCard } from '../../../SubAgentLimitExceedCard';
import { DeniedBySanctions } from '../../../DeniedBySanctions';

export const restrictionTypeToComponent: Record<ERestrictionType, React.ReactElement | null> = {
  [ERestrictionType.SubAgentLimitExceeded]: <SubAgentPublicationLimitExceedCard />,
  [ERestrictionType.DeniedBySanctions]: <DeniedBySanctions />,
  [ERestrictionType.DeniedByStrategy]: null,
};
